



$(document).ready(function() {
// click button "Get a Price Match" on product page
    jQuery(document).on("click",".product-details .button-group a.button.button-hollow.button-medium.button-expanded.price-match",function() {
    jQuery(".product-details a.betterPriceLink").trigger("click");
})

  function fgcUpdateAddToCartTextBySelectedVariant() {
    var stockJsonElement = $("script[data-stock-json]").first();
    var productJsonElement = $("script[data-product-json]").first();
    var variantSelector = $("select[name='id']").first();
    var addToCartText = $("[data-add-to-cart-text]").first();
    var addToCartButton = addToCartText.closest("button.add-to-cart, [data-add-to-cart]");

    if (!stockJsonElement.length || !variantSelector.length || !addToCartText.length) {
      return;
    }

    var stockData, productData;
    try {
      stockData = JSON.parse(stockJsonElement.html());
      productData = productJsonElement.length ? JSON.parse(productJsonElement.html()) : null;
    } catch (error) {
      return;
    }

    var selectedVariantId = variantSelector.val();

    if (productData && productData.variants) {
      var selectedOptions = $("[data-single-option-selector]").map(function() {
        return String($(this).val());
      }).get();

      if (selectedOptions.length) {
        var selectedVariant = productData.variants.find(function(variant) {
          return selectedOptions.every(function(optionValue, index) {
            return String(variant.options[index]) === optionValue;
          });
        });

        if (selectedVariant) {
          selectedVariantId = selectedVariant.id;
        }
      }
    }

    var selectedVariantStock = stockData[selectedVariantId];
    if (!selectedVariantStock) {
      return;
    }

    var selectedVariantQty = Number(selectedVariantStock.inventory_quantity);
    var totalInventoryQty = Object.keys(stockData).reduce(function(total, variantId) {
      return total + Number(stockData[variantId].inventory_quantity || 0);
    }, 0);

    if (totalInventoryQty <= 0) {
      fgcUpdateAvailabilityMessage(selectedVariantQty > 0);
    }

    if (addToCartButton.hasClass("js-loading")) {
      return;
    }

    if (addToCartButton.hasClass("added")) {
      fgcSetAddToCartIcon(addToCartButton, addToCartText, "check");
      return;
    }

    var buttonText = selectedVariantQty > 0
      ? ((window.theme && window.theme.strings && window.theme.strings.addToCart) || "Add to Cart")
      : "Order it in for me";

    if ($.trim(addToCartText.text()) !== buttonText) {
      addToCartText.text(buttonText);
    }

    if (selectedVariantQty > 0) {
      fgcSetAddToCartIcon(addToCartButton, addToCartText, "cart");
    } else {
      addToCartButton.find(".fgc-add-to-cart-icon").remove();
    }

    addToCartButton
      .toggleClass("fgc-add-to-cart-in-stock", selectedVariantQty > 0)
      .toggleClass("out-of-stock", selectedVariantQty <= 0);
  }

  function fgcUpdateAvailabilityMessage(isInStock) {
    var availabilityWrapper = $(".availability-message-wrapper").first();
    if (!availabilityWrapper.length) {
      return;
    }

    var availabilityMessage = availabilityWrapper.children(".availability-message").first();

    if (!availabilityWrapper.data("fgc-original-availability-html")) {
      availabilityWrapper.data("fgc-original-availability-html", availabilityMessage.length ? availabilityMessage.prop("outerHTML") : "");
    }

    if (isInStock) {
      if (!availabilityMessage.length) {
        availabilityWrapper.append('<div class="availability-message"></div>');
        availabilityMessage = availabilityWrapper.children(".availability-message").first();
      }

      availabilityWrapper.addClass("availability-message-wrapper--in-stock");
      availabilityMessage
        .attr("class", "availability-message availability-message--in-stock fgc-istock")
        .html(
          '<div class="availability-message__title ggg">' +
            '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="icon"><path d="M9 .875C4.52.875.875 4.52.875 9S4.52 17.125 9 17.125 17.125 13.48 17.125 9 13.48.875 9 .875zM7.516 13.077L4.367 9.58l.93-.837 2.187 2.43 5.188-6.177.958.802-6.114 7.28z"></path></svg>' +
            'In Stock' +
          '</div>' +
          '<div class="availability-message__content"></div>'
        );
    } else {
      var originalAvailabilityHtml = availabilityWrapper.data("fgc-original-availability-html");
      availabilityMessage.remove();
      availabilityWrapper.removeClass("availability-message-wrapper--in-stock");
      if (originalAvailabilityHtml) {
        availabilityWrapper.append(originalAvailabilityHtml);
      }
    }
  }

  function fgcSetAddToCartIcon(addToCartButton, addToCartText, iconType) {
    var nativeIconSelector = iconType === "check" ? "[data-added-to-cart-icon]" : "[data-add-to-cart-icon]";
    if (addToCartButton.find(nativeIconSelector).length) {
      addToCartButton.find(".fgc-add-to-cart-icon").remove();
      return;
    }

    var currentIcon = addToCartButton.find(".fgc-add-to-cart-icon").first();

    if (currentIcon.attr("data-icon-type") === iconType) {
      return;
    }

    var iconSvg = iconType === "check"
      ? '<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" class="icon"><path d="M31.82 72.16L7.95 48.3 0 56.25l31.82 31.82L100 19.89l-7.95-7.96z"></path></svg>'
      : '<svg class="icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M18.936 5.564c-.144-.175-.35-.207-.55-.207h-.003L6.774 4.286c-.272 0-.417.089-.491.18-.079.096-.16.263-.094.585l2.016 5.705c.163.407.642.673 1.068.673h8.401c.433 0 .854-.285.941-.725l.484-4.571c.045-.221-.015-.388-.163-.567z"></path><path d="M17.107 12.5H7.659L4.98 4.117l-.362-1.059c-.138-.401-.292-.559-.695-.559H.924c-.411 0-.748.303-.748.714s.337.714.748.714h2.413l3.002 9.48c.126.38.295.52.942.52h9.825c.411 0 .748-.303.748-.714s-.336-.714-.748-.714zm-6.683 3.73a1.498 1.498 0 11-2.997 0 1.498 1.498 0 012.997 0zm6.429 0a1.498 1.498 0 11-2.997 0 1.498 1.498 0 012.997 0z"></path></svg>';

    currentIcon.remove();
    addToCartText.before(
      '<span class="fgc-add-to-cart-icon" data-icon-type="' + iconType + '" aria-hidden="true">' +
        iconSvg +
      '</span>'
    );
  }

  if (!$("#fgc-add-to-cart-button-style").length) {
    $("head").append(
      '<style id="fgc-add-to-cart-button-style">' +
        'button.add-to-cart.fgc-add-to-cart-in-stock,' +
        '[data-add-to-cart].fgc-add-to-cart-in-stock{' +
          'background:#2051ac!important;' +
          'border-color:#2051ac!important;' +
          'color:#fff!important;' +
        '}' +
        'button.add-to-cart.fgc-add-to-cart-in-stock:hover:not(:disabled):not(.no-hover),' +
        '[data-add-to-cart].fgc-add-to-cart-in-stock:hover:not(:disabled):not(.no-hover){' +
          'background:#071b40!important;' +
          'border-color:#071b40!important;' +
        '}' +
        '.fgc-add-to-cart-icon{' +
          'display:inline-flex;' +
          'align-items:center;' +
          'margin-right:8px;' +
          'vertical-align:middle;' +
        '}' +
        '.fgc-add-to-cart-icon .icon{' +
          'display:block;' +
          'width:16px;' +
          'height:16px;' +
          'fill:currentColor;' +
        '}' +
      '</style>'
    );
  }

  fgcUpdateAddToCartTextBySelectedVariant();
  setTimeout(fgcUpdateAddToCartTextBySelectedVariant, 500);
  $(document).on("change click", "select[name='id'], [data-single-option-selector], .single-option-selector", function() {
    setTimeout(fgcUpdateAddToCartTextBySelectedVariant, 0);
    setTimeout(fgcUpdateAddToCartTextBySelectedVariant, 100);
    setTimeout(fgcUpdateAddToCartTextBySelectedVariant, 300);
  });

  var addToCartTextNode = document.querySelector("[data-add-to-cart-text]");
  if (addToCartTextNode && window.MutationObserver) {
    new MutationObserver(function() {
      setTimeout(fgcUpdateAddToCartTextBySelectedVariant, 0);
    }).observe(addToCartTextNode.closest("button.add-to-cart, [data-add-to-cart]") || addToCartTextNode, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });
  }
  
   if ($("script[data-stock-json]").length > 0) {
  setTimeout(() => {
        const stockJsonElement = $("script[data-stock-json]");
    if (!stockJsonElement.length) {
      // Không tìm thấy script => thoát hoặc xử lý khác
      console.log("No script[data-stock-json] found.");
      return;
    }
    
    const stockJsonText = stockJsonElement.html();
    if (!stockJsonText) {
      // Script có tồn tại nhưng không có nội dung
      console.log("Script[data-stock-json] is empty.");
      return;
    }
    
    let inventoryData;
    try {
      inventoryData = JSON.parse(stockJsonText);
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return;
    }
    
    // let inventoryData = JSON.parse($("script[data-stock-json]").html());
    let inventoryValues = Object.values(inventoryData);
    const qty = inventoryValues?.[0]?.inventory_quantity;
    const continueSelling = inventoryValues?.[0]?.continue_selling || false; 

    if (continueSelling) {
      $('span[data-add-to-cart-error]').html("").removeClass('visible');
      return;
    }

    function handleOutOfStock() {
      if (qty === 0) {
        $('span[data-add-to-cart-error]').html("The product is out of stock.").addClass('visible');
        $('button.add-to-cart').prop('disabled', true);
        return true;
      }
      return false;
    }

    function updateQuantity(value) {
      if (value > qty) {
        $('input[fgc-check-quantity]').val(qty);
        $('.js-quantity-add').prop('disabled', true);
        $('span[data-add-to-cart-error]').html(`Only ${qty} products in stock for purchase`).addClass('visible');
      } else {
        $('.js-quantity-add, .js-quantity-remove').prop('disabled', false);
        $('span[data-add-to-cart-error]').html("").removeClass('visible');
      }
    }

    $('input[fgc-check-quantity]').change((e) => {
      updateQuantity(Number(e.target.value));
    });

    $('button.js-quantity-add').click((e) => {
      if (handleOutOfStock()) {
        e.preventDefault();
      } else {
        let currentValue = Number($('input[fgc-check-quantity]').val());
        currentValue++;
        updateQuantity(currentValue);
      }
    });

    $('button.js-quantity-remove').click((e) => {
      let currentValue = Number($('input[fgc-check-quantity]').val());
      currentValue--;
      updateQuantity(currentValue);
    });

    $('button.add-to-cart').click((e) => {
      if (handleOutOfStock()) {
        e.preventDefault();
      } else {
        $('span[data-add-to-cart-error]').html("").removeClass('visible');
      }
    });
  }, 1000);
   }

  var updateSortBy = setInterval(function () {
      if ($('select.ais-SortBy-select').length > 0) {
        let urlParams = new URLSearchParams(window.location.search);
        let hasSearchQuery = $.trim(urlParams.get('q') || '').length > 0;
        if (urlParams.size === 0 || (urlParams.size === 1 && urlParams.has('q') && !hasSearchQuery)) {
            $("select.ais-SortBy-select").val("shopify_products_recently_ordered_count_desc");
            document.querySelector('select.ais-SortBy-select').dispatchEvent(new Event('change'));
            setTimeout(function() { 
              $("#shopify-section-search .search-results-algolia #algolia_instant_hogan .ais-block").show();
            }, 350);
        } else {
          $("#shopify-section-search .search-results-algolia #algolia_instant_hogan .ais-block").show();
        }
        clearInterval(updateSortBy);
      }
  }, 5);


// recaptcha
  const submitBtn = $(".custom-create-account .fgc-custom-button");
    const confirmRobotMsg = $(".confirm-robot");

    submitBtn.prop("disabled", true);
    confirmRobotMsg.hide();

    window.recaptchaCallback = function() {
        submitBtn.prop("disabled", false);
        confirmRobotMsg.hide();
    };

    window.recaptchaExpiredCallback = function() {
        submitBtn.prop("disabled", true);
    };

    $("#create_customer").on("submit", function(event) {
        if (grecaptcha.getResponse() === "") {
            event.preventDefault();
            confirmRobotMsg.show();
        }
    });

  //The issue with the arrow icon in the mobile menu.
    $('a.has-children.fgc-custom_menu-mobile').click(function(event) {
    event.preventDefault();
  });
  //end The issue with the arrow icon in the mobile menu.
});
